<template><div><h1 id="mailchimp" tabindex="-1"><a class="header-anchor" href="#mailchimp"><span>MailChimp</span></a></h1>
<p>MailChimp — Anbindung an MailChimp</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Frame erfolgt die Zuordnung der Empfänger an eine MailChimp Kampagne.</p>
<p>Pfad: <code v-pre>Datenaustausch → MailChimp</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Job-ID</dt>
<dd>Eindeutige fortlaufende Nummer für die Identifikation der Kampagne (wird vom System vergeben).</dd>
<dt>Kampagne</dt>
<dd>Bezeichnung der Kampagne</dd>
<dt>Versanddatum</dt>
<dd>Datum des Versandes inkl. Uhrzeit</dd>
<dt>Anzahl</dt>
<dd>Anzahl der Empfänger</dd>
<dt>Status</dt>
<dd>Status der Kampagne. Folgende Stati sind möglich:
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>erfasst, Parametrisierung unvollständig</td>
<td>Die Kampagne ist erfasst, aber die Parametrisierung (in MailChimp) ist noch nicht vollständig.</td>
</tr>
<tr>
<td>erfasst, bereit zum Versand</td>
<td>Die Kampagne ist erfasst aber noch nicht versendet.</td>
</tr>
<tr>
<td>Adressexport gestartet</td>
<td>Der Adressexport zu MailChimp wurde gestartet</td>
</tr>
<tr>
<td>Adressexport abgeschlossen</td>
<td>Der Adressexport zu MailChimp ist erfolgreich abgeschlossen</td>
</tr>
<tr>
<td>Ereignisverknüpfung gestartet</td>
<td>Die Ereignisverknüofungen werden durchgeführt.</td>
</tr>
<tr>
<td>Ereignisverknüpfung abgeschlossen</td>
<td>Die Ereignisse wurden erfolgreich verknüpft.</td>
</tr>
<tr>
<td>Versand gestartet</td>
<td>Der Versand wurde gestartet.</td>
</tr>
<tr>
<td>Versand an MailChimp übermittelt</td>
<td>Der Versand wurde erfolgreich an MailChimp übermittelt</td>
</tr>
<tr>
<td>abgeschlossen, versendet</td>
<td>Die Kampagne wurde erfolgreich versendet.</td>
</tr>
</tbody>
</table>
</dd>
<dt>Empfänger aus</dt>
<dd>Auswahl der Empfänger aus Personenfilter oder Segmentierung</dd>
<dt>Filter</dt>
<dd>Eingabe/Auswahl des Filters</dd>
<dt>Segmentierung</dt>
<dd>Eingabe/Auswahl einer Segmentierung</dd>
<dt>Ereignis</dt>
<dd>Eingabe/Auswahl eines Ereignisses</dd>
<dt>Ereignisposition</dt>
<dd>Eingabe/Auswahl der Ereignisposition</dd>
<dt>Ereignisstatus</dt>
<dd>Eingabe/Auswahl der Ereignisstatus</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="kampagne-senden" tabindex="-1"><a class="header-anchor" href="#kampagne-senden"><span>Kampagne senden...</span></a></h3>
<p>Senden der Kampagne (siehe <RouteLink to="/referenz/refs/ft.refproc.kampagnesenden.html" title="Kampagne senden">Kampagne senden...</RouteLink>).</p>
<h3 id="kampagnen-aktualisieren" tabindex="-1"><a class="header-anchor" href="#kampagnen-aktualisieren"><span>Kampagnen aktualisieren...</span></a></h3>
<p>Aktualisiert alle bestehenden Kampagnen und importiert neue Kampagnen aus MailChimp.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/schnittstelle/mailchimp.html" title="6. MailChimp (E-Mail)">MailChimp (E-Mail)</RouteLink></p>
</div></template>


